<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <modal :name="modalName" width="100%" :clickToClose="false" height="940px" @before-open="beforeOpen" @before-close="beforeClose">
      <v-card>
          <v-toolbar card color="white">
              <div class="flex xs12 sm2">
                  <v-select
                          :items="[{
                          text: '기사 고유번호',
                          value: 'id'
                        },
                        {
                          text: '전화번호',
                          value: 'phoneNumber'
                        },
                        {
                          text: '이름',
                          value: 'name'
                        },
                        {
                          text: '소속',
                          value: 'driverType'
                        },
                        {
                          text: '회사명',
                          value: 'company'
                        },
                        {
                          text: '사용상태',
                          value: 'state'
                        }]"
                          name="header"
                          v-model="searchFormModel.filter"
                          label="header"
                  ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'driverType'">
                  <v-select
                          :items="[{
                            text: 'PERSONAL',
                            value: 'PERSONAL'
                          },
                          {
                            text: 'COMPANY',
                            value: 'COMPANY'
                          }]"
                          single-line
                          label="선택"
                          v-model="searchFormModel.filterText"
                  ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                  <v-select
                          :items="state"
                          label="선택"
                          item-text="text"
                          item-value="state"
                          single-line
                          v-model="searchFormModel.filterText"
                  >
                  </v-select>
              </div>

              <v-text-field
                      v-show="searchFormModel.filter !== 'state' && searchFormModel.filter !== 'driverType'"
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>
              <v-btn icon @click="searchFilter">
                  <v-icon>filter_list</v-icon>
              </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
              <v-data-table
                      :headers="complex.headers"
                      :items="complex.items"
                      :rows-per-page-items="[10,25,50]"
                      :total-items="totalItems"
                      :pagination.sync="pagination"
                      class="elevation-1"
                      item-key="id"
                      must-sort
                      v-model="complex.selected"
              >
                  <template slot="items" slot-scope="props">
                      <td>
                          <v-checkbox
                                  primary
                                  hide-details
                                  v-model="selectedIds"
                                  :value="props.item.id"
                          ></v-checkbox>
                      </td>
                      <td class="text-sm-center"><a @click="openDetail(props.item.id)">{{ props.item.id }}</a></td>
                      <td class="text-sm-center" >{{ props.item.personalInfo.name }}</td>
                      <td class="text-sm-center" >{{ props.item.personalInfo.birthDay }}</td>
                      <td class="text-sm-center" >{{ props.item.personalInfo.gender === 'M' ? '남자' : '여자' }}</td>
                      <td class="text-sm-center" >{{ props.item.phoneNumber }}</td>
                      <td class="text-sm-center" >{{ props.item.driverType }}</td>
                      <td class="text-sm-center" >{{ props.item.companyName }}</td>
                      <td class="text-sm-center" >{{ props.item.taxi == null ? '-' : props.item.taxi.taxiNum }}</td>
                      <td class="text-sm-center" >{{ props.item.taxi == null ? '-' : props.item.taxi.carModelName }}</td>
                      <td class="text-sm-center" >{{ props.item.businessNumber }}</td>
                      <td class="text-sm-center" >{{ props.item.regDate }}</td>
                  </template>
              </v-data-table>
          </v-card-text>
          <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn color="blue darken-1" flat @click="apply">적용</v-btn>
              <v-btn color="blue darken-1" flat @click="closeModal">닫기</v-btn>
          </v-card-actions>
      </v-card>
  </modal>
</template>

<script>
  import State  from '@/api/state';

  export default {
    components: {},
    data : function() {
      return {
          pagination: {
              sortBy: 'id',
              descending: true,
              rowsPerPage: 10,
              page: 1
          },
          searchFormModel: {
              filter: 'id',
              filterText: ''
          },
          totalItems: 0,
          complex: {
              selected: [],
              headers: [
                  {
                      text: '기사 고유번호',
                      value: 'id',
                      align: 'center'
                  },
                  {
                      text: '이름',
                      value: 'name',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '생년월일',
                      value: 'birthDay',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '성별',
                      value: 'gender',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '휴대전화번호',
                      value: 'phoneNumber',
                      align: 'center'
                  },
                  {
                      text: '소속',
                      value: 'driverType',
                      align: 'center'
                  },
                  {
                      text: '회사명',
                      value: 'companyName',
                      align: 'center'
                  },
                  {
                      text: '차량번호',
                      value: 'taxiNum',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '차량모델명',
                      value: 'carModelName',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '개인사업자번호(운수사번)',
                      value: 'businessNumber',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '가입일',
                      value: 'regDate',
                      align: 'center'
                  }
              ],
              items: []
          },
          selectedIds: [],
          state: State,
          callback: null
      }
    },
    props : {
      modalName: {
        required: false,
        default: 'modal-driver-selector',
      }
    },
    watch: {
      pagination: {
          handler () {
              this.banbanCreated();
          },
          deep: true
      },
      'searchFormModel.filter' () {
          this.searchFormModel.filterText = '';
      }
    },
    mounted () {

    },
    methods: {
      beforeOpen (e) {
          if(e.params.callback) {
              this.callback = e.params.callback;
          }
      },
      beforeClose () {
        this.clearModalData();
      },
      clearModalData() {
        this.pagination = {
              sortBy: 'id',
              descending: true,
              rowsPerPage: 10,
              page: 1
        };
        this.searchFormModel = {
              filter: 'id',
              filterText: ''
        };
        this.complex.items = [];
        this.complex.selected = [];
        this.selectedIds = [];
        this.totalItems = 0;
        this.callback = null;
      },
      closeModal () {
        this.beforeClose();
        this.$modal.hide(this.modalName);
      },
      apply () {
          if(this.callback !== null) {
              this.callback(this.selectedIds);
          }

          this.closeModal();
      },
        banbanCreated () {
            const parameters = {
                method: 'searchDrivers',
                pageNum: this.pagination.page - 1,
                pageSize: this.pagination.rowsPerPage,
                sortName: this.pagination.sortBy,
                order: this.pagination.descending == true ? 'desc' : 'asc',
                filter: this.searchFormModel.filter,
                filterText: this.searchFormModel.filterText
            };
            this.$store.dispatch('banbanAPI', parameters)
                .then(({ data }) => {
                    if (data.statusCode != null && data.statusCode != '200'){
                        throw data.message;
                    }

                    this.complex.items = data.content;
                    this.totalItems = data.totalElements;
                    top.getApp.progress.dialog = false;
                })
                .catch((error) => {
                    if (top.getApp.commonError == null) {
                        alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                    }
                    top.getApp.commonError = null;
                    top.getApp.progress.dialog = false;
                });
        },
      searchFilter () {
        this.banbanCreated();
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/modal/modal-driver-selector.vue